export default "__VITE_ASSET__6235b1b8__"